import React, { useState } from 'react';
interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  content?: React.ReactNode;
}
interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  activeTab?: string;
  onChange?: (tabId: string) => void;
  children?: React.ReactNode;
}
export function Tabs({
  tabs,
  defaultTab,
  activeTab: controlledActiveTab,
  onChange,
  children
}: TabsProps) {
  const [internalActiveTab, setInternalActiveTab] = useState(defaultTab || tabs[0]?.id || '');
  // Use controlled or uncontrolled state
  const activeTab = controlledActiveTab !== undefined ? controlledActiveTab : internalActiveTab;
  const setActiveTab = (tabId: string) => {
    if (onChange) {
      onChange(tabId);
    } else {
      setInternalActiveTab(tabId);
    }
  };
  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;
  return <div data-id="element-4049">
      <div className="border-b border-gray-200 dark:border-gray-700" data-id="element-4050">
        <nav className="flex gap-4" aria-label="Tabs" data-id="element-4051">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium
                border-b-2 -mb-px transition-colors
                ${activeTab === tab.id ? 'border-sky-500 text-sky-600 dark:text-sky-400' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'}
              `} data-id="element-4052">
              {tab.icon}
              {tab.label}
            </button>)}
        </nav>
      </div>
      <div className="pt-6" data-id="element-4053">{activeTabContent || children}</div>
    </div>;
}
interface TabPanelProps {
  id: string;
  activeTab: string;
  children: React.ReactNode;
}
export function TabPanel({
  id,
  activeTab,
  children
}: TabPanelProps) {
  if (id !== activeTab) return null;
  return <div data-id="element-4054">{children}</div>;
}